document.addEventListener('DOMContentLoaded', function () {

  // --- DOM refs ---
  var collectionSelect = document.getElementById('collection-selector');
  var grid             = document.getElementById('collection-product-grid');
  var materialSelect   = document.getElementById('collection-selector-material');
  var lightsSelect     = document.getElementById('collection-selector-number');
  var sortSelect       = document.getElementById('sort-by');

  var collectionSelectM = document.getElementById('collection-selector-mobile');
  var materialSelectM   = document.getElementById('collection-selector-material-mobile');
  var lightsSelectM     = document.getElementById('collection-selector-number-mobile');
  var sortSelectM       = document.getElementById('sort-by-mobile');

  if (!grid) return;

  var syncing = false;

  function syncPair(els, source, value) {
    if (!els || !els.length) return;
    syncing = true;
    els.forEach(function (el) {
      if (!el || el === source || el.value === value) return;
      if (window.jQuery && jQuery(el).data('select2')) {
        jQuery(el).val(value).trigger('change.select2');
      } else {
        el.value = value;
      }
    });
    syncing = false;
  }

  function getCollectionEls() {
    return [collectionSelect, collectionSelectM].filter(Boolean);
  }
  function getMaterialEls() {
    return [materialSelect, materialSelectM].filter(Boolean);
  }
  function getLightsEls() {
    return [lightsSelect, lightsSelectM].filter(Boolean);
  }
  function getSortEls() {
    return [sortSelect, sortSelectM].filter(Boolean);
  }

  // --- Select2: desktop row only (sidebar uses native <select> so dropdowns work inside overflow panels) ---
  var select2Selector = [
    '#collection-selector',
    '#collection-selector-material',
    '#collection-selector-room',
    '#collection-selector-number',
    '#sort-by'
  ].join(', ');

  $(select2Selector).select2({
    minimumResultsForSearch: Infinity,
    width: 'resolve'
  });

  // --- Separate products from editorial blocks ---
  var allProducts = [];
  var editorialBlocks = [];

  grid.querySelectorAll('.ec-item').forEach(function (el) {
    if (el.classList.contains('ec-block')) {
      editorialBlocks.push({
        element: el,
        position: parseInt(el.getAttribute('data-shopify-editor-block') || '0', 10),
        gridSize: el.classList.contains('ec-item--1x2') ? '1x2' : (el.classList.contains('ec-item--2x2') ? '2x2' : '1x1')
      });
    } else {
      allProducts.push(el);
    }
  });

  // Store original position index for each editorial block (position in the DOM among all .ec-item)
  (function () {
    var allItems = Array.from(grid.querySelectorAll('.ec-item'));
    editorialBlocks.forEach(function (block) {
      var idx = allItems.indexOf(block.element);
      var productsBefore = 0;
      for (var i = 0; i < idx; i++) {
        if (!allItems[i].classList.contains('ec-block')) productsBefore++;
      }
      block.afterProduct = productsBefore;
    });
  })();

  // --- Event bindings (sync + behavior) ---
  getCollectionEls().forEach(function (el) {
    $(el).on('change', function () {
      if (syncing) return;
      syncPair(getCollectionEls(), this, this.value);
      reloadCollectionGrid();
    });
  });

  getMaterialEls().forEach(function (el) {
    $(el).on('change', function () {
      if (syncing) return;
      syncPair(getMaterialEls(), this, this.value);
      renderGrid();
    });
  });

  getLightsEls().forEach(function (el) {
    $(el).on('change', function () {
      if (syncing) return;
      syncPair(getLightsEls(), this, this.value);
      renderGrid();
    });
  });

  getSortEls().forEach(function (el) {
    $(el).on('change', function () {
      if (syncing) return;
      syncPair(getSortEls(), this, this.value);
      renderGrid();
    });
  });

  // --- Reload grid from server (collection switch) ---
  function reloadCollectionGrid() {
    var handle = collectionSelect ? collectionSelect.value : '';
    var url = '/collections/' + handle;

    grid.classList.add('fade-out');

    fetch(url, { cache: 'no-store' })
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var parser  = new DOMParser();
        var doc     = parser.parseFromString(html, 'text/html');
        var newGrid = doc.querySelector('#collection-product-grid');

        if (newGrid) {
          var currentMaterial = materialSelect ? materialSelect.value : 'all';
          var currentLights   = lightsSelect ? lightsSelect.value : 'all';

          grid.innerHTML = newGrid.innerHTML;

          allProducts = [];
          editorialBlocks = [];
          var allItems = Array.from(grid.querySelectorAll('.ec-item'));
          allItems.forEach(function (el) {
            if (el.classList.contains('ec-block')) {
              var productsBefore = 0;
              for (var i = 0; i < allItems.indexOf(el); i++) {
                if (!allItems[i].classList.contains('ec-block')) productsBefore++;
              }
              editorialBlocks.push({
                element: el,
                afterProduct: productsBefore,
                gridSize: el.classList.contains('ec-item--1x2') ? '1x2' : (el.classList.contains('ec-item--2x2') ? '2x2' : '1x1')
              });
            } else {
              allProducts.push(el);
            }
          });

          if (materialSelect) materialSelect.value = currentMaterial;
          if (lightsSelect) lightsSelect.value = currentLights;
          if (materialSelectM) materialSelectM.value = currentMaterial;
          if (lightsSelectM) lightsSelectM.value = currentLights;
          if (materialSelect && $(materialSelect).data('select2')) {
            $(materialSelect).trigger('change.select2');
          }
          if (lightsSelect && $(lightsSelect).data('select2')) {
            $(lightsSelect).trigger('change.select2');
          }

          if (window.lazySizes) lazySizes.autoSizer.checkElems();

          renderGrid();
          updateFilterCounts();
        }

        grid.classList.remove('fade-out');
        grid.classList.add('fade-in');
        setTimeout(function () { grid.classList.remove('fade-in'); }, 300);
      })
      .catch(function (err) {
        console.error('Error fetching collection:', err);
        grid.classList.remove('fade-out');
      });
  }

  // --- Render grid: sort, filter, insert editorial blocks, pair 1x2 ---
  var renderTimer = null;
  function renderGrid() {
    clearTimeout(renderTimer);
    grid.classList.add('fade-out');

    renderTimer = setTimeout(function () {
      var sortVal          = (sortSelect && sortSelect.value) ? sortSelect.value : 'manual';
      var selectedMaterial = materialSelect ? materialSelect.value.toLowerCase() : '';
      var selectedLights   = lightsSelect ? lightsSelect.value : 'all';

      // Sort products
      var items = allProducts.slice();
      if (sortVal === 'price-ascending') {
        items.sort(function (a, b) {
          return (parseInt(a.getAttribute('data-price'), 10) || 0)
               - (parseInt(b.getAttribute('data-price'), 10) || 0);
        });
      } else if (sortVal === 'price-descending') {
        items.sort(function (a, b) {
          return (parseInt(b.getAttribute('data-price'), 10) || 0)
               - (parseInt(a.getAttribute('data-price'), 10) || 0);
        });
      } else if (sortVal === 'created-descending') {
        items.sort(function (a, b) {
          return (b.getAttribute('data-created') || '').localeCompare(a.getAttribute('data-created') || '');
        });
      } else {
        items.sort(function (a, b) {
          return (parseInt(a.getAttribute('data-position'), 10) || 0)
               - (parseInt(b.getAttribute('data-position'), 10) || 0);
        });
      }

      // Filter products
      var filtered = [];
      items.forEach(function (product) {
        var productMaterials = (product.getAttribute('data-material') || '').toLowerCase();
        var productLights    = parseInt(product.getAttribute('data-lightcount'), 10);
        var materialMatch = selectedMaterial === 'all' || productMaterials.indexOf(selectedMaterial) !== -1;
        var lightsMatch   = selectedLights === 'all' || (!isNaN(productLights) && productLights >= parseInt(selectedLights, 10));
        if (materialMatch && lightsMatch) {
          filtered.push(product);
        }
      });

      // Clear grid (including any pair wrappers from previous render)
      grid.querySelectorAll('.ec-item, .ec-pair').forEach(function (el) { el.remove(); });

      // Reset all product grid classes to their original metafield value
      filtered.forEach(function (product) {
        var original = product.getAttribute('data-grid-size') || '1x1';
        product.classList.remove('ec-item--1x1', 'ec-item--1x2', 'ec-item--2x2');
        product.classList.add('ec-item--' + original);
      });

      // Build final list: insert editorial blocks at their positions
      var finalList = [];
      var productIndex = 0;
      var blocksByPosition = {};
      editorialBlocks.forEach(function (b) {
        blocksByPosition[b.afterProduct] = b;
      });

      for (var i = 0; i < filtered.length; i++) {
        finalList.push(filtered[i]);
        productIndex++;
        if (blocksByPosition[productIndex]) {
          finalList.push(blocksByPosition[productIndex].element);
        }
      }
      // Handle editorial blocks at position 0 (before any product)
      if (blocksByPosition[0]) {
        finalList.unshift(blocksByPosition[0].element);
      }

      // Apply 1x2 pairing: if an editorial block is 1x2, force the product after it to 1x2
      for (var j = 0; j < finalList.length; j++) {
        var el = finalList[j];
        if (el.classList.contains('ec-block') && el.classList.contains('ec-item--1x2')) {
          if (j + 1 < finalList.length && !finalList[j + 1].classList.contains('ec-block')) {
            finalList[j + 1].classList.remove('ec-item--1x1', 'ec-item--2x2');
            finalList[j + 1].classList.add('ec-item--1x2');
            j++;
          }
        }
      }

      // Also handle product-to-product 1x2 pairing (only for products with 1x2 in their metafield)
      for (var k = 0; k < finalList.length; k++) {
        var item = finalList[k];
        if (!item.classList.contains('ec-block') && item.getAttribute('data-grid-size') === '1x2') {
          var next = finalList[k + 1];
          if (next && !next.classList.contains('ec-block')) {
            next.classList.remove('ec-item--1x1', 'ec-item--2x2');
            next.classList.add('ec-item--1x2');
            k++;
          }
        }
      }

      // Identify consecutive 1x2 pairs for side-by-side wrapping
      var pairStart = {};
      for (var m = 0; m < finalList.length - 1; m++) {
        if (finalList[m].classList.contains('ec-item--1x2') &&
            finalList[m + 1].classList.contains('ec-item--1x2')) {
          pairStart[m] = true;
          m++;
        }
      }

      // Append everything, wrapping 1x2 pairs in a full-width container
      for (var n = 0; n < finalList.length; n++) {
        if (pairStart[n]) {
          var wrapper = document.createElement('div');
          wrapper.className = 'ec-pair';
          wrapper.appendChild(finalList[n]);
          wrapper.appendChild(finalList[n + 1]);
          grid.appendChild(wrapper);
          n++;
        } else {
          grid.appendChild(finalList[n]);
        }
      }

      if (window.lazySizes) lazySizes.autoSizer.checkElems();

      grid.classList.remove('fade-out');
      grid.classList.add('fade-in');
      setTimeout(function () { grid.classList.remove('fade-in'); }, 300);
    }, 150);
  }

  // --- Hide filter options with 0 results ---
  function updateFilterCounts() {
    var matPrimary = materialSelect || materialSelectM;
    var lightsPrimary = lightsSelect || lightsSelectM;
    var lightsVal = lightsPrimary ? lightsPrimary.value : 'all';
    var matVal = matPrimary ? matPrimary.value : 'all';

    [materialSelect, materialSelectM].filter(Boolean).forEach(function (sel) {
      Array.from(sel.options).forEach(function (option) {
        if (option.value === 'all') { option.style.display = ''; return; }
        var count = 0;
        allProducts.forEach(function (product) {
          var mats   = (product.getAttribute('data-material') || '').toLowerCase();
          var lights = parseInt(product.getAttribute('data-lightcount'), 10);
          var lMatch = lightsVal === 'all' || (!isNaN(lights) && lights >= parseInt(lightsVal, 10));
          if (mats.indexOf(option.value.toLowerCase()) !== -1 && lMatch) count++;
        });
        option.style.display = count > 0 ? '' : 'none';
      });
    });

    [lightsSelect, lightsSelectM].filter(Boolean).forEach(function (sel) {
      Array.from(sel.options).forEach(function (option) {
        if (option.value === 'all') { option.style.display = ''; return; }
        var count = 0;
        allProducts.forEach(function (product) {
          var mats   = (product.getAttribute('data-material') || '').toLowerCase();
          var lights = parseInt(product.getAttribute('data-lightcount'), 10);
          var mMatch = matVal === 'all' || mats.indexOf(matVal.toLowerCase()) !== -1;
          if (!isNaN(lights) && lights >= parseInt(option.value, 10) && mMatch) count++;
        });
        option.style.display = count > 0 ? '' : 'none';
      });
    });
  }

  updateFilterCounts();

  // --- Mobile sidenav (filter / sort drawers) ---
  var shell = document.querySelector('.ec-collection-filters-shell');
  if (!shell) return;

  var backdrop = shell.querySelector('.ec-sidenav-backdrop');
  var panelFilter = document.getElementById('ec-sidenav-filter');
  var panelSort = document.getElementById('ec-sidenav-sort');
  var mqDesktop = window.matchMedia('(min-width: 769px)');

  function openPanel(which) {
    if (mqDesktop.matches) return;
    var panel = which === 'sort' ? panelSort : panelFilter;
    var other = which === 'sort' ? panelFilter : panelSort;
    if (!panel || !backdrop) return;
    if (other) {
      other.classList.remove('is-open');
      other.setAttribute('aria-hidden', 'true');
      other.setAttribute('hidden', '');
    }
    panel.removeAttribute('hidden');
    backdrop.hidden = false;
    requestAnimationFrame(function () {
      backdrop.classList.add('is-open');
      panel.classList.add('is-open');
      panel.setAttribute('aria-hidden', 'false');
    });
    document.body.classList.add('ec-sidenav-open');
    shell.querySelectorAll('[data-ec-open]').forEach(function (btn) {
      btn.setAttribute('aria-expanded', btn.getAttribute('data-ec-open') === which ? 'true' : 'false');
    });
  }

  function closePanels() {
    if (!backdrop) return;
    backdrop.classList.remove('is-open');
    [panelFilter, panelSort].forEach(function (panel) {
      if (!panel) return;
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
    });
    document.body.classList.remove('ec-sidenav-open');
    shell.querySelectorAll('[data-ec-open]').forEach(function (btn) {
      btn.setAttribute('aria-expanded', 'false');
    });
    setTimeout(function () {
      if (backdrop && !backdrop.classList.contains('is-open')) {
        backdrop.hidden = true;
        if (panelFilter && !panelFilter.classList.contains('is-open')) panelFilter.setAttribute('hidden', '');
        if (panelSort && !panelSort.classList.contains('is-open')) panelSort.setAttribute('hidden', '');
      }
    }, 320);
  }

  shell.addEventListener('click', function (e) {
    var t = e.target.closest('[data-ec-open]');
    if (t) {
      e.preventDefault();
      openPanel(t.getAttribute('data-ec-open'));
      return;
    }
    if (e.target.closest('[data-ec-close]')) {
      e.preventDefault();
      closePanels();
    }
  });

  if (backdrop) {
    backdrop.addEventListener('click', function () { closePanels(); });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && document.body.classList.contains('ec-sidenav-open')) {
      closePanels();
    }
  });

  mqDesktop.addEventListener('change', function () {
    if (mqDesktop.matches) closePanels();
  });
});
